module.exports = __webpack_public_path__ + "img/Image1.5c391ab8.png";